// pages/mind-mesch/Faq.js

import React from 'react';

const Faq = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Frequently Asked Questions</h1>
      <div style={{ marginTop: '1.5rem' }}>
        <h3>What is Mind Mesch?</h3>
        <p>Mind Mesch is a cognitive support and memory mesh platform built to help users structure thoughts, track insights, and interact with AI partners.</p>

        <h3>Who is it for?</h3>
        <p>It’s designed for individuals, professionals, and organizations that need structured recall, partner APIs, and AI-enhanced context tracking.</p>

        <h3>Is it secure?</h3>
        <p>Yes. Your data is encrypted and managed across secure infrastructure with optional dedicated IP and role-based API access.</p>

        <h3>How do I get started?</h3>
        <p>Visit <a href="https://mind-mesch.daisypal.com" target="_blank" rel="noopener noreferrer">mind-mesch.daisypal.com</a> and sign up. You’ll get access to the platform and optional API usage right away.</p>
      </div>
    </div>
  );
};

export default Faq;
